import { useParams } from "react-router-dom";
import { NewcomerDossierPanel } from "../../components/newcomer/NewcomerDossierPanel";

export function NewcomerDossierPage() {
  const { token } = useParams();
  return <NewcomerDossierPanel mode="public" token={token} />;
}
